import { Card, Row, Spin } from "antd";
import { memo, useCallback, useMemo } from "react";
import { KPI_CODES } from "../kpiCodes";
import { useGetAccWithPaymentRestrictions } from "../hooks/useGetAccWithPaymentRestrictions";
import { Bar } from "@ant-design/plots";
import { CHART_PAID_OFF } from "../../../lib/constants";
import ROUTES from "../../../configs/routesConfig";
import { useNavigate } from "react-router-dom";

type AccountsWithPRProps = {
  data: any;
  isLoading: boolean;
};

const AccountsWithPR = ({ data, isLoading }: AccountsWithPRProps) => {
  const { accountsStat, statMap } = useGetAccWithPaymentRestrictions(data);

  const navigate = useNavigate();

  const total: string = useMemo(() => {
    const kpi = data
      ? data.kpiValues.find(
          (item: any) => item.code === KPI_CODES.ACCOUNTS_PAYMENT_RESTRICTIONS,
        )
      : null;

    return kpi ? kpi.value : "No Data";
  }, [data]);

  const navigateToUrl = useCallback(
    (restriction: number) => {
      const url: string = `${ROUTES.ACCOUNTS}?statusFilter=0&paymentRestriction=${restriction}&isOther=false`;

      navigate(url);
    },
    [navigate],
  );

  const config: any = useMemo(
    () => ({
      data: accountsStat,
      xField: "Total",
      yField: "label",
      minBarWidth: 12,
      maxBarWidth: 12,
      height: 350,
      color: CHART_PAID_OFF,
      xAxis: {
        grid: {
          line: {
            style: {
              lineWidth: 1,
              lineDash: [4, 5],
            },
          },
        },
      },
      yAxis: {
        label: {
          style: {
            fontSize: 14,
            cursor: "pointer",
          },
          autoEllipsis: true,
        },
      },
      barStyle: {
        cursor: "pointer",
      },
      onReady: (plot: any) => {
        plot.on("element:click", (args: any) => {
          const restriction: number = args.data.data.key;

          navigateToUrl(restriction);
        });
        plot.on("axis-label:click", (args: any) => {
          const label = args.gEvent.target.attrs.text;

          if (isNaN(+label)) {
            const firstWord: string = label.split(" ")[0];

            const statMapKeyes: string[] = Object.keys(statMap);

            let restriction: number = 0;
            statMapKeyes.forEach((key: string) => {
              const itemFirstWord = statMap[key].label.split(" ")[0];

              if (itemFirstWord === firstWord) {
                restriction = statMap[key].key;
              }
            });

            navigateToUrl(restriction);
          }
        });
      },
    }),
    [accountsStat, navigateToUrl, statMap],
  );

  return (
    <Card className="dashboard-card top">
      <p className="text mt-0 mb-2">Accounts with Payment Restrictions</p>
      {!isLoading ? (
        <>
          <h3 className="h h3 mb-4">{total}</h3>
          <div>
            <Bar {...config} />
          </div>
        </>
      ) : (
        <Row className="h-100 justify-center align-center">
          <Spin size="large" />
        </Row>
      )}
    </Card>
  );
};

export default memo(AccountsWithPR);
